// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.7.1",
  date: "2026-08-21T12:48:09.993Z",
  gitInfo: {
    dirty: false,
    raw: "e3f74050a",
    hash: "e3f74050a",
    distance: null,
    tag: null,
    semver: null,
    suffix: "e3f74050a",
    semverString: null
  }
};
/* tslint:enable */
